export default function NoMatch() {
  return <div>404 Not Found</div>;
}
